/*
For date format options please see:
https://imask.js.org/

USAGE:
    blue.ready('customDateMask', '.dateMask input', (dateMask) => {
        blue.plug.inputMask(dateMask);
    })

PUG:
	//this project is setup to allow the following usage by default, however this can be changed or expanded upon in components/forms.js
	.formBlock.dateMask
        label(for='birthday').formLabel Birthday
        input(type='text',required).formInput#birthday
*/
import IMask from 'imask';
(function() {
	(blue.plug.inputMask = inputElement => {
		const now = new Date()
		IMask(inputElement, {
			mask: Date,
			pattern: 'm/`d/`Y',
			// define date -> str convertion
			format: function (date) {
				var day = date.getDate();
				var month = date.getMonth() + 1;
				var year = date.getFullYear();
		
				if (day < 10) day = "0" + day;
				if (month < 10) month = "0" + month;
		
				return [month, day, year].join('/');
			},
			// define str -> date convertion
			parse: function (str) {
				var monthDayYear = str.split('/');
				return new Date(monthDayYear[2], monthDayYear[0] - 1, monthDayYear[1]);
			},
			min: new Date(1900, 0, 1),  // defaults to `1900-01-01`
			max: new Date(now.getFullYear() - 18, 0, 1),  // defaults to `9999-01-01`
			overwrite: true
		});
	});
})();
